import { FilterHandlerBase } from './base/filter-handler-base';
import { AdvancedFilterName, FilterPassParams } from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { filterMaturityByYear } from '../../../grid/utils/filter/maturities-filters';

export class MaturityYearFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.maturityYear;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const maturityYear = params.filters[this.name];
    const data = params.deal;
    let isMaturityYearFilterPassed = true;
    if (maturityYear) {
      isMaturityYearFilterPassed = data.maturities.some(mat =>
        filterMaturityByYear(maturityYear.model, mat)
      );
    }
    result.applyDealFilerResult(data.id, this.name, isMaturityYearFilterPassed);

    return isMaturityYearFilterPassed;
  }
}
